import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useAlerts } from '../../custom/Alerts';

/* Modalni prozor sa naslovom, "Sačuvaj" akcijom i upozorenjem pri zatvaranju sa nesačuvanim izmenama. */
export default function FormDialog({
    visible, title, onClose, onSave, canSave = true, dirty = false, busy = false,
    saveLabel = 'Sačuvaj', width = '40rem', children, hideSave = false,
}) {
    const alerts = useAlerts();
    const [saving, setSaving] = useState(false);

    const close = async () => {
        if (dirty && !(await alerts.confirm('Potvrdi', 'Postoje izmene koje nisu sačuvane. Da li ste sigurni da želite da napustite ovaj prozor?'))) return;
        onClose();
    };

    const save = async () => {
        setSaving(true);
        try { await onSave(); } finally { setSaving(false); }
    };

    return (
        <Dialog visible={visible} header={title} onHide={close} style={{ width, maxWidth: '96vw' }} modal draggable dismissableMask
            footer={hideSave ? null : (
                <div className="dialog-footer">
                    <Button label="Otkaži" severity="secondary" text onClick={close} />
                    <Button label={saveLabel} icon="pi pi-check" onClick={save} disabled={!canSave || busy || saving} loading={saving} />
                </div>
            )}>
            {busy ? <div className="empty-state compact" role="status"><i className="pi pi-spin pi-spinner" aria-hidden="true" /> Učitavanje...</div> : children}
        </Dialog>
    );
}

/** Prompt sa jednim tekstualnim poljem (dodavanje marke/modela). */
export function PromptDialog({ visible, title, label, onClose, onOk }) {
    const [value, setValue] = useState('');
    return (
        <Dialog visible={visible} header={title} onHide={() => { setValue(''); onClose(); }} style={{ width: '28rem' }} modal
            footer={(
                <div className="dialog-footer">
                    <Button label="Otkaži" severity="secondary" text onClick={() => { setValue(''); onClose(); }} />
                    <Button label="Sačuvaj" icon="pi pi-check" disabled={!value.trim()} onClick={() => { onOk(value.trim()); setValue(''); }} />
                </div>
            )}>
            <div className="form-grid" style={{ gridTemplateColumns: '1fr' }}>
                <div className="field">
                    <label htmlFor="prompt-value">{label}</label>
                    <input id="prompt-value" className="p-inputtext p-component" value={value} autoFocus onChange={(e) => setValue(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter' && value.trim()) { onOk(value.trim()); setValue(''); } }} />
                </div>
            </div>
        </Dialog>
    );
}
